import { render } from "./TheSaveButton.vue?vue&type=template&id=2788b8fd&scoped=true"
import script from "./TheSaveButton.vue?vue&type=script&lang=js"
export * from "./TheSaveButton.vue?vue&type=script&lang=js"

import "./TheSaveButton.vue?vue&type=style&index=0&id=2788b8fd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2788b8fd"

export default script